export type CompanyType = 'MINI' | 'STANDARD' | 'PLUS' | 'GROUP' | 'PLUS_LIMITED';

export enum CompanyTypeEnum {
    'MINI' = 'Mini',
    'STANDARD' = 'Standard',
    'PLUS' = 'Plus',
    'GROUP' = 'Gruppföretag',
    'PLUS_LIMITED' = 'Plus Enskild Lista',
}
